import styled from 'styled-components';
import {
  FaSearch as FaSearchIcon,
  FaTimes as FaRemoveIcon
} from 'react-icons/fa';
import { color, font, media } from '@morressier/ts';

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid var(--color-mono-60);
  background-color: ${color('white')};
  margin-bottom: 5rem;
  ${media.medium`
    width: 24rem;
  `}
  ${media.large`
    width: 32rem;
  `}
  &:focus-within,
  &:hover {
    border-color: ${color('secondaryBrand')};
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const SearchIcon = styled(FaSearchIcon)`
  font-size: 16px;
  margin-right: 12px;
  color: ${color('grey')};
  cursor: pointer;
`;

export const SearchInput = styled.input`
  display: flex;
  width: 100%;
  font-size: 1rem;
  line-height: 24px;
  border: 0;
  color: ${color('secondaryBrand')};
  background-color: transparent;
  &:focus {
    outline: none;
  }
  height: 40px;
  padding: 8px 8px 8px 16px;
`;

export const RemoveIcon = styled(FaRemoveIcon)`
  font-size: 22.78px;
  margin-right: 2px;
  color: ${color('grey')};
  cursor: pointer;
`;

export const SearchHeadline = styled.div`
  font-style: normal;
  ${font('Orleans')}
  color: ${color('secondaryBrand')};
  font-weight: 900;
  ${media.xxsmall`
    font-size: 1.5rem;
    line-height: 2rem;
  `}
  ${media.small`
    font-size: 2rem;
    line-height: 2.5rem;
  `}
`;
